import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { cssProp } from "./helpers";

const Spacer = styled.div<{
	pt?: string;
	pb?: string;
	pr?: string;
	pl?: string;
	ml?: string;
	mr?: string;
	mt?: string;
	mb?: string;
	padding?: string;
	margin?: string;
	display?: string;
}>(
	({ pt, pb, pr, pl, ml, mr, mt, mb, padding, margin, display }) => css`
		${cssProp("padding", padding)}
		${cssProp("padding-top", pt)}
		${cssProp("padding-bottom", pb)}
		${cssProp("padding-left", pl)}
		${cssProp("padding-right", pr)}
		${cssProp("margin", margin)}
		${cssProp("margin-top", mt)}
		${cssProp("margin-bottom", mb)}
		${cssProp("margin-left", ml)}
		${cssProp("margin-right", mr)}
		${cssProp("display", display)}
	`
);

export default Spacer;
